import { Component, OnInit } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'ct-banner',
  templateUrl: './ct-banner.component.html',
  styleUrls: ['./ct-banner.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': "getStyleClass()",
  }
})
export class CtBannerComponent extends CtrlBaseComponent {

  imageName: string;
  imagePosition: string;
  imageText: string;
  title: string;
  descriptionText: string;

  constructor() {
    super();
  }

  setImageName(imageName: string): void { this.imageName = imageName }
  setImagePosition(imagePosition: string): void { this.imagePosition = imagePosition }
  setImageText(imageText: string): void { this.imageText = imageText }
  setTitle(title: string): void { this.title = title }
  setDescriptionText(descriptionText: string): void { this.descriptionText = descriptionText }

  getImageName(): string { return this.imageName }
  getImagePosition(): string { return this.imagePosition }
  getImageText(): string { return this.imageText }
  getTitle(): string { return this.title }
  getDescriptionText(): string { return this.descriptionText }

  getInnerHTML(){
    return '<h5 class="text-primary mt-0 mb-1">'+this.getTitle()+'</h5>'+this.getDescriptionText()
  }

}
